import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNut = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 2000 2000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinejoin: "round",
		strokeMiterlimit: 2
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "matrix(1.04683,0,0,1.05281,-1356.26,-2072.51)",
		children: [/* @__PURE__ */ _jsxs("g", {
			transform: "matrix(7.58859e-17,1.23931,-1.23931,7.58859e-17,3748.81,1591.18)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M1070.93,638.441L1564.79,923.571L1564.79,1493.83L1070.93,1778.96L577.074,1493.83L577.074,923.571L1070.93,638.441Z",
				style: {
					fill: "rgb(235,235,235)",
					fillOpacity: 0
				}
			}), /* @__PURE__ */ _jsx("path", { d: "M1733.41,825.387L1733.41,1592.01L1070.93,1974.49L408.46,1592.01L408.46,825.387L1070.93,442.908L1733.41,825.387ZM1070.93,638.441L577.074,923.571L577.074,1493.83L1070.93,1778.96L1564.79,1493.83L1564.79,923.571L1070.93,638.441Z" })]
		}), /* @__PURE__ */ _jsxs("g", {
			transform: "matrix(1.59928,0,0,1.59928,821.471,1416.11)",
			children: [/* @__PURE__ */ _jsx("circle", {
				cx: 893.764,
				cy: 939.353,
				r: 175.226,
				style: {
					fill: "rgb(235,235,235)",
					fillOpacity: 0
				}
			}), /* @__PURE__ */ _jsx("path", { d: "M893.764,663.161C1046.36,663.161 1170.53,786.761 1170.53,939.353C1170.53,1091.95 1046.36,1215.55 893.764,1215.55C741.171,1215.55 616.996,1091.95 616.996,939.353C616.996,786.761 741.171,663.161 893.764,663.161ZM893.764,764.127C797.054,764.127 718.538,842.643 718.538,939.353C718.538,1036.06 797.054,1114.58 893.764,1114.58C990.474,1114.58 1068.99,1036.06 1068.99,939.353C1068.99,842.643 990.474,764.127 893.764,764.127Z" })]
		})]
	})
});
export default SvgNut;
